import { render } from "./ModalPaper.vue?vue&type=template&id=448eb191&scoped=true"
import script from "./ModalPaper.vue?vue&type=script&lang=js"
export * from "./ModalPaper.vue?vue&type=script&lang=js"

import "./ModalPaper.vue?vue&type=style&index=0&id=448eb191&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-448eb191"

export default script